<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span
          class="headline"
        >
          Session Idle...
        </span>
      </v-card-title>
      <v-card-text
        class="pa-0"
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="idle-message"
            >
              Your session will be expired due to inactivity in {{ second }} seconds.
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  // Utilities
  import { mapActions } from 'vuex'

  export default {
    name: 'IdleDialog',

    data: () => ({
      time: 60000,
      show: true,
    }),

    computed: {
      second () {
        return this.time / 1000
      },
    },

    created () {
      const timerId = setInterval(() => {
        this.time -= 1000
        if (!this.isAppIdle) clearInterval(timerId)

        if (this.time < 1) {
          clearInterval(timerId)
          this.signOut()
        }
      }, 1000)
    },

    methods: {
      ...mapActions('oidcStore', [
        'signOutOidc',
      ]),

      signOut: function () {
        this.signOutOidc().then(() => {
          this.$router.push('/pages/logout')
        })
      },
    },
  }
</script>

<style lang="sass">
  .idle-message
    text-align: center !important
    font-size: 1.5625rem !important
    font-weight: 400
    line-height: 1.4em
    letter-spacing: normal !important
    font-family: "Roboto", sans-serif !important
</style>
